module.exports = __webpack_public_path__ + "img/treat.a0df15f7.gif";